import { Container, Row } from "react-bootstrap";
import SubTiltle from "../Uitily/SubTiltle";
import ProductCard from "./ProductCard";
import CardContainerHook from "./../../hook/products/card-container-hook";
import LoadingIntro from "../Loading/LoadingIntro";

const CardProductsContainer = ({ title, btntitle, pathText, products }) => {
  const [favProd] = CardContainerHook();

  return (
    <Container className="my-5">
      {products ? (
        <SubTiltle title={title} btntitle={btntitle} pathText={pathText} />
      ) : null}
      <Row className="my-2">
        {products ? (
          products.map((item, index) => (
            <ProductCard favProd={favProd} key={index} item={item} />
          ))
        ) : (
          <LoadingIntro />
        )}
      </Row>
    </Container>
  );
};

export default CardProductsContainer;
